var ptxStdLib = {
    userdata : {
        person: {
            "name" : "Scott",
            "color" : "blue",
            "gender" : "male",
            "height" : "62",
        },
        clothing:{
            "shoesize" : "12",
            "shirtsize" : "M",
            "pantwidth" : "32",
            "pantlength" : "30",
        },
        subscriptions: ['premium'],
        trackingprefs : 'deny',
        preferredlocation: [112, 45, "My House"],
        newsletters: ['fortnight', 'weekly', 'podcast'],
        onboarding: ['menu', 'social'],
        interests: ['hiking', 'biking', 'dogs', 'cats'],
        diets: ['meat', 'vegan', 'vegetarian', 'dairy'],
        itineraries: [
            ["Favorites", 42, 100], // Index zero cannot be deleted
            ["Monday Morning", 32, 182, 22],
         ],
         location_current:"44.8512305,-123.1867655", // Independence
         location_primary:"44.8484524,-123.2339888",
    },
    allowDynamicChanges: true,
    previousDynamicColor: 'rgba(0,0,0,1)',
    elements : {
        'colorMetatag' :  document.querySelector('meta[name="theme-color"]'),
    },
    /**
     * Process Locations
     * 
     * Uses the current location to set a distance value on elements with a data-location attribute.
     * This is used in sorting functions and when the location is changed, these values must be recalculated.
     */
    processLocations: function(){
        // alert('process');
        // Starting Geolocation
        var start = ptxStdLib.userdata.location_current.split(",");
        var lat1 = start[0];
        var lon1 = start[1];
        var allDistances = [];
        
        // Extract data-location will also get data-distance and data
        jQuery('[data-location]').each(function(){
            var locations = jQuery(this).attr("data-location").split(',');
            var lat2 = locations[0];
            var lon2 = locations[1];
            var distance = ptxStdLib.latlngDistance(lat1, lon1, lat2, lon2);
            

            // Maybe move this to the "render"?
            jQuery(this).attr("data-distance", distance);

            /*
            allDistances.push({
                "id" : parseInt(id),
                "distance" : parseFloat(distance),
                "order": false
            });
            */
        });

        /*
        console.log("allDistances !", allDistances);

        // Sort by "distance" value
        allDistances.sort((a, b) => a.distance - b.distance);

        // Sorted
        console.log("allDistances Sorted!", allDistances);

        // Assign 
        allDistances.forEach(function(element, index) {
            element['closest'] = index;
            element['farthest'] = allDistances.length - index;
            // element['closest'] = 'beep';
            // element['farthest'] = 'boop';

            // jQuery(this).attr("data-distance", distance);
            // jQuery(this).attr("data-distance", distance);

            console.log("element, index was: ", element);
        });  
        
        console.log("allDistances Sorted!", allDistances);
        */

    },
    saveUserData: function(){

    },
    saveUserData: function(){

    },
    loudly : function(){
        alert('custom');
    }, 
    addAlpha : function(color, opacity) {
        // coerce values so ti is between 0 and 1.
        var _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
        return color + _opacity.toString(16).toUpperCase();
    },
    isMobile : function(){
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    },
    isIOS : function(){
        var deviceList = ['iPad Simulator','iPhone Simulator','iPod Simulator','iPad','iPhone','iPod'];
        var deviceIncluded = deviceList.includes(navigator.platform)
        var behaviorsIncluded = (navigator.userAgent.includes("Mac") && "ontouchend" in document);
        console.log("deviceIncluded, deviceIncluded", deviceIncluded, behaviorsIncluded);
        return deviceIncluded || behaviorsIncluded;
    },
    highlightNav: function(){

        // Initial Load
        this.handleScrollAnimation();

        let throttleTimer;
 
        const throttle = (callback, time) => {
          if (throttleTimer) return;
            throttleTimer = true;
            setTimeout(() => {
                callback();
                throttleTimer = false;
            }, time);
        }
         
        window.addEventListener("scroll", () => { 
            // this.handleScrollAnimation();
          throttle(this.handleScrollAnimation, 100);
        });
       
    },
    setNavOpen(isShowing){
        ptxStdLib.allowDynamicChanges = !isShowing;
        // Dynamic Color
        var newColor = ptxStdLib.allowDynamicChanges ? ptxStdLib.previousDynamicColor : 'rgb(0,0,0)';
        // Set Color Bar
        ptxStdLib.elements.colorMetatag.setAttribute('content',  newColor);
    },
    monitorNetworkAccess: function(booleanState){
        // Set Initial State
        ptxStdLib.handleNetworkChange(window.navigator.onLine);
        // Set Event Handlers for online/offline
        window.addEventListener('online', () => ptxStdLib.handleNetworkChange(true));
        window.addEventListener('offline', () => ptxStdLib.handleNetworkChange(false));
    },
    handleNetworkChange: function(booleanState){
        var msg = booleanState ? 'online' : 'offline';
        // alert(msg);
        console.log('The Network is: ' + booleanState);
        jQuery('.ptx-site').attr('data-network', msg);

    },
    plasterNavColor: function(style, theme, keycolor){
        ptxStdLib.previousDynamicColor = keycolor;
        if(ptxStdLib.allowDynamicChanges){   
       
            // var randomColor = Math.floor(Math.random()*16777215).toString(16);
            jQuery('.ptx-primarynav').attr('style',style).attr('data-theme',theme);
        //    keycolor = 'rgb(0,0,0)';
            // setTimeout(function(){
            console.log("before");
            console.log('key!',   keycolor);
            ptxStdLib.elements.colorMetatag.setAttribute('content',  ptxStdLib.rgba2hex(keycolor)); // '#' + 
            console.log("after");
            // }, 350)
      
        }
        // console.log("plaster with " + section.id);
    },
    rgba2hex: function (color) {
        if (/^rgb/.test(color)) {
            const rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',');
        
            // rgb to hex
            // eslint-disable-next-line no-bitwise
            let hex = `#${((1 << 24) + (parseInt(rgba[0], 10) << 16) + (parseInt(rgba[1], 10) << 8) + parseInt(rgba[2], 10))
              .toString(16)
              .slice(1)}`;
        
            // added alpha param if exists
            if (rgba[4]) {
              const alpha = Math.round(0o1 * 255);
              const hexAlpha = (alpha + 0x10000).toString(16).substr(-2).toUpperCase();
              hex += hexAlpha;
            }
        
            return hex;
          }
          return color;
    },
    latlngDistance: function(lat1, lon1, lat2, lon2, unit) {
            var decimalPlaces = 2;
            var radlat1 = Math.PI * lat1/180
            var radlat2 = Math.PI * lat2/180
            var theta = lon1-lon2
            var radtheta = Math.PI * theta/180
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            dist = Math.acos(dist)
            dist = dist * 180/Math.PI
            dist = dist * 60 * 1.1515
            if (unit=="K") { dist = dist * 1.609344 }
            if (unit=="N") { dist = dist * 0.8684 }
            var numericalDistance = $.isNumeric(dist) ? dist : 0;
            return numericalDistance.toFixed(decimalPlaces);
    },
    degToCardinal: function(num) {
        var val = Math.floor((num / 22.5) + 0.5);
        var arr = ["N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE", "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW"];
        var key = arr[(val % 16)];
        // Remove 3 letter cardinals, too obscure
        var simplekey = key && key.length == 3 ? key.substring(1, 3) : key;
        return simplekey;
    },
    angle360: function (cx, cy, ex, ey) {
        var decimalPlaces = 2;
        var theta = ptxStdLib.angle(cx, cy, ex, ey); // range (-180, 180]
        if (theta < 0) theta = 360 + theta; // range [0, 360)
        return theta.toFixed(decimalPlaces);
    },
    angle: function (cx, cy, ex, ey) {
        var dy = ey - cy;
        var dx = ex - cx;
        var theta = Math.atan2(dy, dx); // range (-PI, PI]
        theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
        return theta;
    },
    handleScrollAnimation: function(){
        // alert('bep');
        const sections = document.querySelectorAll('.xx-styled--colorchange'); // xx-styled--block
        const distancetoTop = window.pageYOffset;
        // const selectedSection = undefined;
      //  console.clear();
        console.log("window offset", distancetoTop);
        console.log("sections", sections);
        // DO nothing when there are no sections
        if(sections.length == 0){return false;}
      

        sections.forEach((section, i) => {
           const navHeight = 0; // // 60 account for the fixed nav  / 2
            //  const navHeight = 0;
            const sectionHeight = section.clientHeight;
            const sectionTop = section.offsetTop - navHeight;
            const sectionBottom = sectionTop + sectionHeight;
            const sectionInView = distancetoTop >= sectionTop && distancetoTop <= sectionBottom;
            
            if(sectionInView){
                // console.log("section height", sectionHeight);
 
                var theme = jQuery(section).attr('data-theme');
                var style = jQuery(section).attr('style');
                // var style = jQuery(section).attr('style');
                const computedStyle = getComputedStyle(section);
                // var keycolor = computedStyle.backgroundColor;
                var keycolor = computedStyle.getPropertyValue('--interfaceKeyColor');
                // console.log("style", keycolor);
                /*
                console.log("keycolor", keycolor);
                // // if(section.offsetTop)
                console.log(sections);
                console.log("section offset from top", sectionTop);
                console.log("section bottom", sectionBottom);
                console.log("theme", theme);
                console.log("style", style);
                */
                // console.log("section is");
                // console.log(section); // .offsetTop
                ptxStdLib.plasterNavColor(style, theme, keycolor);
            }

            // console.log("window offset is");
            // console.log(distancetoTop);
        });
    },
    userInterface : {
        'navloaded' : false
    }
  
   
}

// Start observing immediately, but not in the admin
if(!jQuery('html').hasClass('wp-toolbar')){
    ptxStdLib.monitorNetworkAccess();
    ptxStdLib.highlightNav();
}

